<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img
            src="@/assets/456.jpg"
            class="user-avatar"
          />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <div v-if="userinfoType == 'super_admin'" class="right-menu"> -->
    <div v-if="userinfoType == 'admin'" class="right-menu">
      <el-select
        v-model="tableData"
        filterable
        :placeholder="
          $store.state.consolelanguagedata.Pleaseselectanorganization
        "
        value-key="name"
        @change="schools_show"
      >
        <!-- <el-option
          v-for="item in tableDatas"
          :key="item.corp_id"
          :label="item.name"
          :value="item"
        /> -->
        <el-option
          v-for="item in orgData"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
    </div>
    <!-- <div v-if="userinfoType != 'super_admin'" class="right-menu"> -->
    <div v-if="userinfoType != 'admin'" class="right-menu">
      <!-- 请选择学校 -->
      <el-select
        v-model="tableData"
        filterable
        :placeholder="
          $store.state.consolelanguagedata.Pleaseselectanorganization
        "
        value-key="name"
        @change="schools_show"
      >
        <!-- <el-option
          v-for="item in tableDatas"
          :key="item.corp_id"
          :label="item.name"
          :value="item"
        /> -->
        <el-option
          v-for="item in orgData"
          :key="item.id"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
    </div>
    <!-- <div v-if="userinfoType == 'super_admin'" class="right-menu"> -->
    <!-- <div v-if="userinfoType == 'admin'" class="right-menu">
      请选择组织类型
      <el-select
        v-model="corp_type"
        filterable
        :placeholder="
          $store.state.consolelanguagedata.Pleaseselectanorganizationtype
        "
        value-key="value_name"
        @change="corp_types_show"
      >
        <el-option
          v-for="item in corp_types"
          :key="item.value_code"
          :label="item.value_name"
          :value="item"
        />
      </el-select>
    </div> -->
    <consolelanguage class="right-menu" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeToken } from '@/utils/auth'
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import consolelanguage from "@/components/consolelanguage";
// 【脏代码清理】后端已无 getcorp_type 路由，原 import 中的 getcorp_type 注释停用
import {
  getschools,
  get_orgs_by_parent_id,
  // getcorp_type,
} from "@/api/schools";
export default {
  components: {
    Breadcrumb,
    Hamburger,
    consolelanguage,
  },
  data() {
    return {
      // userinfoType: localStorage.getItem("consoleuserinfoType"),
      userinfoType: JSON.parse(localStorage.getItem("usersInfos")).username,
      corpId: "",
      form: {},
      pageSize: "1000",
      // tableDatas:
      //   localStorage.getItem("consolegetcorp_types") != "undefined"
      //     ? JSON.parse(localStorage.getItem("consolegetcorp_types"))
      //     : "",
      // 组织name
      // corp_type:
      //   localStorage.getItem("consolecorptypes_name") != "undefined"
      //     ? localStorage.getItem("consolecorptypes_name")
      //     : "",
      tableDatas: [], // 组织列表
      corp_type: {}, //组织类型对象
      corp_types: [], //组织类型列表
      tableData: {}, //组织对象
      orgData: [],
      orgType: [], //存放用户所属的组织
      // 学校name
      // tableData:
      //   localStorage.getItem("consolecorpName") != "undefined"
      //     ? localStorage.getItem("consolecorpName")
      //     : ""
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
  },
  mounted() {
    // alert(11);
    this.getcorp_Types();
    this.get_org_type();
  },
  methods: {
    get_org_type() {
      const userInfo = JSON.parse(localStorage.getItem("usersInfos"));
      const data = {
        page_num: 1,
        page_size: 1000,
      };
      if (userInfo.role !== "系统操作管理员") {
        data.parent_id = userInfo.corp_id;
      }
      get_orgs_by_parent_id(data).then((response) => {
        this.orgData = response.result;
        localStorage.setItem('son_org_data',JSON.stringify(response.result))
        this.tableData = localStorage.getItem("select_org");
        this.orgType = this.orgData;
        if(localStorage.getItem("select_org")){
          this.tableData= localStorage.getItem("select_org")
        }else{
          this.tableData= response.result[0].name;
           const result = this.orgType.find((item) => item.name === this.tableData);
           localStorage.setItem("create_class_from_id", JSON.stringify(result.id));
      localStorage.setItem(
        "create_class_corp_name",
        JSON.stringify(result.name)
      );
        }

      });
    },
    corp_types_show(e) {
      // localStorage.setItem("consolecorptypes_type", this.corp_type.value_code);
      // localStorage.setItem("consolecorptypes_name", this.corp_type.value_name);
      localStorage.setItem("consolecorptypes_type", this.corp_type.name);
      localStorage.setItem("consolecorptypes_name", this.corp_type.name);
      this.tableDatas = [];
      this.tableData = "";
      localStorage.removeItem("consolecorpId");
      localStorage.removeItem("consolecorpName");
      this.getSchools();
    },
    // 选择学校
    schools_show(e) {
      localStorage.setItem("select_org", e);
      this.tableData = e;
      const result = this.orgType.find((item) => item.name === e);
      localStorage.setItem("create_class_from_id", JSON.stringify(result.id));
      localStorage.setItem(
        "create_class_corp_name",
        JSON.stringify(result.name)
      );
      location.reload();
    },
    getcorp_Types() {
      const userInfo = JSON.parse(localStorage.getItem("usersInfos"));
      const data = {};
      if (userInfo.role !== "系统操作管理员") {
        data.parent_id = userInfo.corp_id;
      }
      get_orgs_by_parent_id(data).then((res) => {
        this.corp_types = res.result;
        if (localStorage.getItem("consolecorptypes_type")) {
          this.corp_type = {
            value_code: localStorage.getItem("consolecorptypes_type"),
            value_name: localStorage.getItem("consolecorptypes_name"),
          };
          this.getSchools();
        } else if (
          JSON.parse(localStorage.getItem("consoleuserinfoTypeResult")).industry
        ) {
          this.corp_type = this.corp_types.find(
            (item) =>
              item.value_code ==
              JSON.parse(localStorage.getItem("consoleuserinfoTypeResult"))
                .industry
          );
          localStorage.setItem(
            "consolecorptypes_type",
            this.corp_type.value_code
          );
          localStorage.setItem(
            "consolecorptypes_name",
            this.corp_type.value_name
          );
          //直接获取学生列表
          this.getSchools();
        } else {
          //啥也没有  直接不赋值
          this.corp_type = {};
        }
      });
    },
    // 获取用户信息
    getSchools() {
      this.listLoading = true;
      /* 【脏代码清理】后端已无 getcorp_type 路由，原超级管理员调用 getcorp_type 的 if 分支注释停用，保留有效的 getschools 分支
      if (this.userinfoType == "admin") {
        //超级管理员进
        const data = {
          corp_id: JSON.parse(localStorage.getItem("usersInfos")).corp_id,
        };
        getcorp_type(data).then((response) => {
          this.tableDatas = response.result;
          this.tableDatas.push({
            corp_id: "0",
            name: "全部",
          });
          // 赋值 --先判断本地选的有没有  没有再从登陆的缓存拿
          if (localStorage.getItem("consolecorpId")) {
            this.tableData = {
              corp_id: localStorage.getItem("consolecorpId"),
              name: localStorage.getItem("consolecorpName"),
            };
          } else if (
            JSON.parse(localStorage.getItem("consoleuserinfoTypeResult")).corpId
          ) {
            this.tableData = this.tableDatas.find(
              (item) =>
                item.corp_id ==
                JSON.parse(localStorage.getItem("consoleuserinfoTypeResult"))
                  .corpId
            );
            //切换组织类型的时候到这里也会进, 组织类型和 登录的不匹配当然也不保存了
            if (this.tableData) {
              localStorage.setItem("consolecorpId", this.tableData.corp_id);
              localStorage.setItem("consolecorpName", this.tableData.name);
            } else {
              this.tableData = {};
            }
          } else {
            this.tableData = {};
          }
          localStorage.setItem(
            "consolegetcorp_types",
            JSON.stringify(this.tableDatas)
          );
          this.listLoading = false;
        });
      } else {
      */
        //普通老师
        const data = {
          page_num: 1,
          page_size: 1000,
          parent_id: JSON.parse(localStorage.getItem("usersInfos")).corp_id,
        };
        getschools(data).then((response) => {
          this.tableDatas = response.result.list;
          if (localStorage.getItem("consolecorpId")) {
            this.tableData = {
              id: localStorage.getItem("consolecorpId"),
              name: localStorage.getItem("consolecorpName"),
            };
          } else if (
            JSON.parse(localStorage.getItem("consoleuserinfoTypeResult")).corpId
          ) {
            this.tableData = this.tableDatas.find(
              (item) =>
                item.id ==
                JSON.parse(localStorage.getItem("consoleuserinfoTypeResult"))
                  .corpId
            );
            if (this.tableData) {
              localStorage.setItem("consolecorpId", this.tableData.id);
              localStorage.setItem("consolecorpName", this.tableData.name);
            } else {
              this.tableData = {};
            }
          } else {
            this.tableData = {};
          }
          this.listLoading = false;
        });
      /*
      }
      */
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      localStorage.clear();
      removeToken();
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
